// extracted by mini-css-extract-plugin
module.exports = {"error":"error-ty_iB","error-label":"error-label-lyLDv","error-sub":"error-sub-rdwAf","playlist-button":"playlist-button-tZTCo","icon":"icon-fIGRf","label":"label-Z7jSJ"};